import {
  type DataSnapshot,
  type Database,
  type DatabaseReference,
  type FirebaseApp,
  type ListenOptions,
  type Query,
  type Unsubscribe,
  getAppInstance as projectGetAppInstance,
  getDatabase as projectGetDatabase,
  onValue as projectOnValue,
  ref as projectRef,
} from "@restaurant-store-firebase";

type GetAppInstance = () => FirebaseApp;
type GetDatabase = (app?: FirebaseApp, url?: string) => Database;
type OnValue = (
  query: Query,
  callback: (snapshot: DataSnapshot) => unknown,
  cancelCallback: (error: Error) => unknown,
  options: ListenOptions,
) => Unsubscribe;
type Ref = (db: Database, path?: string) => DatabaseReference;

export { type DataSnapshot, type FirebaseApp, type Unsubscribe };
export const getAppInstance: GetAppInstance = projectGetAppInstance;
export const getDatabase: GetDatabase = projectGetDatabase;
export const onValue: OnValue = projectOnValue;
export const ref: Ref = projectRef;
